import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledContainer = styled.div`
  height: 10px;
  width: 100%;
  background-color: ${props => props.theme.colors.backgroundDark};
  border-radius: 50px;
  margin: 4px;
`;

const StyledBar = styled.div`
  height: 100%;
  background-color: ${props => props.theme.colors.primaryLight};
  border-radius: inherit;
  text-align: right;
`;

const ProgressBar = ({ percent }) => {
  return (
    <StyledContainer>
      <StyledBar style={{ width: `${percent}%` }} />
    </StyledContainer>
  );
};

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
};

export default ProgressBar;
